// What the Calendar page reads (U91). Its own json helpers, as the meetings and co-pilot pages have,
// so the portal's api.ts — another track's file — is not touched.
import { viewFetch as fetch } from '../view-as.js';
import { ApiError, Unauthenticated } from '../api.js';

/** What the bot lane decided about a meeting (U99). The API's own words are in copilot/week-store.ts. */
// 'not_held': nobody joined the meeting on Teams, as the bot lane judged it (BUGS.md M52).
export type CaptureState = 'will' | 'now' | 'done' | 'no' | 'failed' | 'not_held';
export interface Capture { state: CaptureState; reason: string | null }

export interface WeekEvent {
  signalId: string;
  /** null where Cobrain does not keep this meeting's words (R42): the page draws "Busy". */
  title: string | null;
  startsAt: string;
  endsAt: string;
  allDay: boolean;
  company: { id: string; name: string } | null;
  people: number;
  /** D52's flag: the week marks it as triage does (U100, D77). */
  private: boolean;
  /** What Cobrain will do about recording it, or null where the lane has not reached it (U99). */
  capture: Capture | null;
}

export interface WeekView { from: string; to: string; events: WeekEvent[] }

export interface BriefLine { text: string; source: string }
export interface Brief {
  company: { id: string; name: string };
  stake: BriefLine[];
  since: BriefLine[];
  usage: BriefLine[];
  around: BriefLine[];
  notSeen: string[];
}
export interface BriefView { brief: Brief | null; why: string | null }

async function json<T>(r: Response): Promise<T> {
  if (r.status === 401) throw new Unauthenticated();
  const body = (await r.json().catch(() => null)) as { error?: string } | null;
  if (!r.ok) throw new ApiError(r.status, body?.error ?? `${r.status}`);
  return body as T;
}

const get = <T>(path: string): Promise<T> => fetch(path, { credentials: 'same-origin' }).then((r) => json<T>(r));
const q = (store: string) => `store=${encodeURIComponent(store)}`;

export const calendar = {
  /** The week that holds `from`, Monday to Sunday; today's week when `from` is left out. */
  week: (store: string, from?: string) => get<WeekView>(`/api/calendar/week?${q(store)}${from ? `&from=${encodeURIComponent(from)}` : ''}`),
  brief: (store: string, signalId: string) => get<BriefView>(`/api/calendar/brief?${q(store)}&signal=${encodeURIComponent(signalId)}`),
};
